export const FIREBASE_CONFIG = {
    apiKey: "AIzaSyBgAhiJ03NbyuP7FkPdyWXWllAuoMv4YRI",
    authDomain: "chronusdieselpenedes.firebaseapp.com",
    databaseURL: "https://chronusdieselpenedes.firebaseio.com",
    projectId: "chronusdieselpenedes",
    storageBucket: "chronusdieselpenedes.appspot.com",
    messagingSenderId: "77681590717"
};


// WEBPACK FOOTER //
// ./src/app/app.firebase.config.ts